import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=f1c7ec4c&scoped=true&"
import script from "./EditProfile.vue?vue&type=script&lang=ts&"
export * from "./EditProfile.vue?vue&type=script&lang=ts&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=f1c7ec4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c7ec4c",
  null
  
)

export default component.exports